// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_szI","cls2":"NewsInteractionBar-cls2_MLa NewsInteractionBar-cls1_szI"};